import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { AlertContext } from "../../context/AlertContext";
import { ConfiguracionContext } from "../../context/ConfiguracionContext";
import { AuthContext } from "../../context/AuthContext";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import ButtonMui from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import Spinner from "./Spinner";
import Menu from "./Menu";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import * as EmailValidator from "email-validator";
import FormControlLabel from "@mui/material/FormControlLabel";

export default function Recibos(props) {
  const [globalFilter, setGlobalFilter] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [recibo, guardarRecibo] = useState(null);
  const [visible, setVisible] = useState(false);
  const [visibleFechas, setVisibleFechas] = useState(false);
  const [numeros, setNumeros] = useState(null);
  const [cobrador, setCobrador] = useState(null);
  const [visibleEnvios, setVisibleEnvios] = useState(false);
  const [emailAddress, guardarEmailAddress] = useState(null);
  const [celular, guardarCelular] = useState(null);
  const [linkEmailEnable, guardarLinkEmailEnable] = useState(null);
  const [emailComprobante, setEmailComprobante] = useState(false);
  const [whatsAppComprobante, setWhatsAppComprobante] = useState(false);
  const [noRendido, setNoRendido] = useState(null);
  const [rendido, setRendido] = useState(null);

  const toast = useRef(null);
  let navigate = useNavigate();

  const exportColumns = [
    { title: "ID", dataKey: "id" },
    { title: "Empresa", dataKey: "empresa_nombre" },
    { title: "Cobrador", dataKey: "cobrador_nombre" },
    { title: "P. Venta", dataKey: "puntoventa" },
    { title: "Número", dataKey: "numero" },
    { title: "Anulado", dataKey: "anulado" },
  ];

  // Context
  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const {
    statusAcceso,
    recibos,
    empresas,
    cobradores,
    configuracion,
    obtenerAcceso,
    obtenerRecibos,
    obtenerEmpresas,
    obtenerCobradores,
    agregarRecibos,
    actualizarRecibo,
    eliminarRecibo,
    anularRecibo,
    crearRecibosPdf,
    enviarEmailRecibo,
    enviarWhatsAppRecibo,
  } = configuracionContext;

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({ usuarioId: state.usuario.id, layout: "Recibos" });
    }
  }, [state]);

  useEffect(() => {
    //obtenerRecibos();
    obtenerEmpresas();
    obtenerCobradores();
  }, []);

  const dataParaExportar = recibos.map((item) => ({
    id: item.id,
    empresa_nombre: item.empresas?.nombre || "",
    cobrador_nombre: item.cobradores?.nombre || "",
    puntoventa: item.puntoventa,
    numero: item.numero,
    anulado: item.anulado ? "Sí" : "No", // Aprovechas para dar formato
  }));

  const editClick = () => {
    if (selectedRow) {
      guardarRecibo({
        ...selectedRow,
        id: selectedRow.id,
        id_empresa: selectedRow.id_empresa || selectedRow.empresas?.id || null,
        id_cobrador:
          selectedRow.id_cobrador || selectedRow.cobradores?.id || null,
        numero: selectedRow.numero,
        puntoventa: selectedRow.puntoventa,
      });
      setVisible(true);
    } else {
      toast.current.show({
        severity: "info",
        summary: "Editar",
        detail: "Debe seleccionar un recibo.",
        life: 3000,
      });
    }
  };

  const calendar = (e) => {
    setVisibleFechas(true);
  };

  const addClick = () => {
    setVisible(true);
    setSelectedRow(null);
    guardarRecibo({
      habilitado: true,
      id_empresa: null,
      id_cobrador: null,
      puntoventa: "",
      desde: "",
      hasta: "",
    });
  };

  const eliminarClick = (e) => {
    if (selectedRow) {
      if (selectedRow.id_rendicion || selectedRow.id_comprobante) {
        toast.current.show({
          severity: "info",
          summary: "Eliminar",
          detail: "Este recibo no se puede eliminar.",
          life: 3000,
        });

        return;
      }

      const numero = selectedRow.numero;
      const pventa = selectedRow.puntoventa;
      const id = selectedRow.id;

      confirmDialog({
        message: `Esta seguro de eliminar el recibo ${pventa}-${numero} de ${selectedRow.empresas.nombre}.`,
        header: "Confirmación",
        icon: "pi pi-exclamation-triangle",
        rejectLabel: "No",
        acceptLabel: "Si",
        accept: () => {
          eliminarRecibo({
            id,
          });
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        },
        //reject: () => reject(),
      });
    } else {
      toast.current.show({
        severity: "info",
        summary: "Eliminar",
        detail: "Debe seleccionar un recibo.",
        life: 3000,
      });
    }
  };

  const anularClick = (e) => {
    if (selectedRow) {
      if (!selectedRow.id_rendicion && !selectedRow.id_comprobante) {
        toast.current.show({
          severity: "info",
          summary: "Anular",
          detail: "Este recibo no se puede anular.",
          life: 3000,
        });

        return;
      }

      const numero = selectedRow.numero;
      const pventa = selectedRow.puntoventa;
      const id = selectedRow.id;

      confirmDialog({
        message: `Esta seguro de anular el recibo ${pventa}-${numero} de ${selectedRow.empresas.nombre}.`,
        header: "Confirmación",
        icon: "pi pi-exclamation-triangle",
        rejectLabel: "No",
        acceptLabel: "Si",
        accept: () => {
          anularRecibo({
            id,
            usuario: state.usuario.usuario,
          });
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        },
        //reject: () => reject(),
      });
    } else {
      toast.current.show({
        severity: "info",
        summary: "Anular",
        detail: "Debe seleccionar un recibo.",
        life: 3000,
      });
    }
  };

  const exitClick = () => {
    navigate("/");
  };

  const onHide = () => {
    setVisible(false);
  };

  const onHideFechas = () => {
    setVisibleFechas(false);
  };

  const aceptarFechas = async (exportType) => {
    //e.preventDefault();
    //Validar

    if (
      !cobrador ||
      cobrador === undefined ||
      cobrador === null ||
      cobrador === "" ||
      cobrador === 0
    ) {
      if (
        !numeros ||
        numeros.desde === undefined ||
        numeros.desde === null ||
        numeros.desde === "" ||
        numeros.desde === 0
      ) {
        mensajeAlerta("Recibos", "Número desde es necesario !.", "error");
        return;
      }
      if (
        !numeros ||
        numeros.hasta === undefined ||
        numeros.hasta === null ||
        numeros.hasta === "" ||
        numeros.hasta === 0
      ) {
        mensajeAlerta("Recibos", "Número hasta es necesario !.", "error");
        return;
      }
    }

    await obtenerRecibos({
      numeros,
      cobrador,
      noRendido,
      rendido,
    });
    onHideFechas();
  };

  const aceptarClick = (e) => {
    e.preventDefault();

    if (!recibo || !recibo.id_empresa) {
      mensajeAlerta("Recibos", "Empresa es necesaria !.", "error");
      return;
    }

    if (!recibo || !recibo.id_cobrador) {
      mensajeAlerta("Recibos", "Cobrador es necesario !.", "error");
      return;
    }

    if (
      recibo.puntoventa === undefined ||
      recibo.puntoventa === null ||
      recibo.puntoventa === "" ||
      Number(recibo.puntoventa) === 0
    ) {
      mensajeAlerta("Recibos", "P. Venta es necesario !.", "error");
      return;
    }

    if (!selectedRow) {
      if (
        recibo.desde === undefined ||
        recibo.desde === null ||
        recibo.desde === "" ||
        Number(recibo.desde) === 0
      ) {
        mensajeAlerta("Recibos", "Número desde es necesario !.", "error");
        return;
      }

      if (
        recibo.hasta === undefined ||
        recibo.hasta === null ||
        recibo.hasta === "" ||
        Number(recibo.hasta) === 0
      ) {
        mensajeAlerta("Recibos", "Número hasta es necesario !.", "error");
        return;
      }

      if (Number(recibo.hasta) < Number(recibo.desde)) {
        mensajeAlerta(
          "Recibos",
          "Número hasta no puede ser menor que número desde !.",
          "error",
        );
        return;
      }
    }

    if (selectedRow) {
      actualizarRecibo({ recibo });
    } else {
      agregarRecibos({ recibo, usuario: state.usuario.usuario });
    }

    onHide();
    setSelectedRow(null);
  };

  const crearLinkPdf = async (rowData) => {
    if (rowData.linkPdf) {
      toast.current.show({
        severity: "info",
        summary: "Visualizar",
        detail: "El link del pdf del comprobante ya esta creado.",
        life: 3000,
      });

      window.open(rowData.linkPdf);
    }

    const data = {
      id_empresa: rowData.id_empresa,
      id_rendicion: rowData.id_rendicion,
    };

    await crearRecibosPdf({
      data,
    }).then((data) => {
      let elem = document.getElementById("actualizarRecibos");
      setTimeout(() => {
        elem.click();
      }, 500);
    });

    //window.location.reload();
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Recibos",
      "No tiene permiso para acceder a esta pantalla !.",
      "error",
    );
    exitClick();
    return;
  };

  const anuladoTemplate = (rowData) => {
    return (
      <Fragment>
        <Checkbox checked={rowData.anulado}></Checkbox>
      </Fragment>
    );
  };

  const enviadoTemplate = (rowData) => {
    return (
      <Fragment>
        <Checkbox checked={rowData.enviado}></Checkbox>
      </Fragment>
    );
  };

  const opcionesTemplate = (rowData) => {
    return (
      <Fragment>
        <Button
          style={{ marginLeft: "0.2vw" }}
          icon="pi pi-file-pdf"
          rounded
          text
          severity={rowData.linkPdf ? "danger" : "secondary"}
          onClick={(e) => crearLinkPdf(rowData)}
          disabled={!rowData.id_titular}
          aria-label="Bookmark"
          tooltip="Link Pdf"
          tooltipOptions={{ position: "bottom" }}
        />

        {configuracion && configuracion.destinatario === 1 ? (
          <Button
            style={{ marginLeft: "0.2vw" }}
            icon="pi pi-send"
            rounded
            text
            severity="success"
            onClick={(e) => enviar(rowData)}
            disabled={!rowData.id_titular}
            aria-label="Bookmark"
            tooltip="Enviar"
            tooltipOptions={{ position: "bottom" }}
          />
        ) : null}
        <Button
          id="actualizarRecibos"
          style={{ marginLeft: "1em", display: "none" }}
          onClick={(e) => {
            obtenerRecibos({
              numeros,
              cobrador,
            });
          }}
        />
      </Fragment>
    );
  };

  const enviar = async (rowData) => {
    let emailsAddress = "";
    if (
      rowData.afiliados &&
      rowData.afiliados.email &&
      rowData.afiliados.email.length > 3
    ) {
      emailsAddress = rowData.afiliados.email;
    }
    if (
      rowData.afiliados &&
      rowData.afiliados.email2 &&
      rowData.afiliados.email2.length > 3
    ) {
      emailsAddress = emailsAddress + ";" + rowData.afiliados.email2;
    }
    if (
      rowData.afiliados &&
      rowData.afiliados.email3 &&
      rowData.afiliados.email3.length > 3
    ) {
      emailsAddress = emailsAddress + ";" + rowData.afiliados.email3;
    }
    if (
      rowData.afiliados &&
      rowData.afiliados.email4 &&
      rowData.afiliados.email4.length > 3
    ) {
      emailsAddress = emailsAddress + ";" + rowData.afiliados.email4;
    }
    if (
      rowData.afiliados &&
      rowData.afiliados.email5 &&
      rowData.afiliados.email5.length > 3
    ) {
      emailsAddress = emailsAddress + ";" + rowData.afiliados.email5;
    }

    emailsAddress = emailsAddress.trim();
    guardarEmailAddress(emailsAddress);

    let celularAfiliado = "";
    if (rowData.afiliados && rowData.afiliados.celular) {
      celularAfiliado = rowData.afiliados.celular.trim();
    }
    guardarCelular(celularAfiliado);

    if (rowData.linkPdf) {
      guardarLinkEmailEnable(rowData.linkPdf);
    } else {
      guardarLinkEmailEnable(null);
    }

    setVisibleEnvios(true);
  };

  const empresaTemplate = (rowData) => {
    return rowData.empresas?.nombre || "";
  };

  const cobradorTemplate = (rowData) => {
    return rowData.cobradores?.nombre || "";
  };

  const rendicionTemplate = (rowData) => {
    return rowData.id_rendicion ?? null;
  };

  const titularTemplate = (rowData) => {
    return rowData.id_titular ?? null;
  };

  const comprobanteTemplate = (rowData) => {
    return rowData.comprobantes
      ? `${rowData.comprobantes.comprobante} - ${rowData.comprobantes.numero}`
      : null;
  };

  const entregaTemplate = (rowData) => {
    return rowData.entrega ? formatDate(rowData.entrega) : null;
  };

  const rendidoTemplate = (rowData) => {
    return rowData.rendido ? formatDate(rowData.rendido) : null;
  };

  function formatDate(dateString) {
    var allDate = dateString.replace("T", " ");
    allDate = allDate.replace(".", " ");
    allDate = allDate.split(" ");
    var thisDate = allDate[0].split("-");
    var newDate = [thisDate[2], thisDate[1], thisDate[0]].join("/");
    return newDate;
  }

  const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(exportColumns, dataParaExportar);
        window.open(doc.output("bloburl"));
      });
    });
  };

  const exportExcel = () => {

    import("xlsx").then((xlsx) => {
      const dataExport =
        recibos?.map((item) => ({
          id: item.id,
          empresa: item.empresas?.nombre || "",
          cobrador: item.cobradores?.nombre || "",
          pVenta: item.puntoventa,
          numero: item.numero,
          rendicion: item.rendiciones?.id_rendicion || "",
          entrega: item.entrega ? formatDate(item.entrega) : null,
          rendido: item.rendido ? formatDate(item.rendido) : null,
          titular: item.id_titular,
          anulado: item.anulado ? "Sí" : "No",
        })) || [];

      const worksheet = xlsx.utils.json_to_sheet(dataExport);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      saveAsExcelFile(excelBuffer, "recibos");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then(() => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      return new Promise((resolve) => {
        saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION,
        );
        resolve(true);
      });
    });
  };

  const header = (
    <Fragment>
      <div className="p-d-flex export-buttons">
        <Button
          type="button"
          icon="pi pi-file-excel"
          onClick={exportExcel}
          className="p-button-success p-mr-2"
          data-pr-tooltip="XLS"
        />
        <Button
          type="button"
          icon="pi pi-file-pdf"
          onClick={exportPdf}
          className="p-button-warning p-mr-2"
          data-pr-tooltip="PDF"
          style={{ marginRight: "1em" }}
        />
        <span
          style={{ marginLeft: "1em", marginRight: "1em" }}
          className="p-input-icon-left"
        >
          <i className="pi pi-search" />
          <InputText
            type="search"
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Buscar"
          />
        </span>
        <Tag value="Recibos"></Tag>
      </div>
    </Fragment>
  );

  const renderHeader = () => {
    return (
      <div>
        <Tag value="Recibo"></Tag>
      </div>
    );
  };

  const renderFooter = () => {
    return (
      <div>
        <ButtonMui
          onClick={aceptarClick}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        <ButtonMui
          onClick={onHide}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  const renderHeaderFechas = () => {
    return (
      <div>
        <Tag value="Recibos"></Tag>
      </div>
    );
  };

  const renderFooterFechas = () => {
    return (
      <div>
        <ButtonMui
          onClick={aceptarFechas}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        <ButtonMui
          onClick={onHideFechas}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  const renderHeaderEnvios = () => {
    return (
      <div>
        <Tag value="Envío de links de recibos"></Tag>
      </div>
    );
  };

  const renderFooterEnvios = () => {
    return (
      <div>
        <ButtonMui
          onClick={(e) => aceptarEnvios(e)}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Enviar
        </ButtonMui>
        <ButtonMui
          onClick={(e) => exitEnvios()}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Salir
        </ButtonMui>
      </div>
    );
  };

  const aceptarEnvios = (e) => {
    e.preventDefault();
    if (
      emailComprobante &&
      emailAddress &&
      (emailAddress === null || emailAddress === "")
    ) {
      mensajeAlerta("Comprobantes", "El email es incorrecto !.", "error");
      return;
    }

    if (
      emailComprobante &&
      emailAddress &&
      !EmailValidator.validate(emailAddress)
    ) {
      mensajeAlerta("Comprobantes", "El email no es válido !.", "error");
      return;
    }

    if (
      whatsAppComprobante &&
      (celular === null || celular === "" || celular.trim().length !== 10)
    ) {
      mensajeAlerta("Comprobantes", "El celular es incorrecto !.", "error");
      return;
    }

    if (emailComprobante) {
      enviarEmailRecibo({
        emailAddress,
        linkEmailEnable,
      });
    }

    if (whatsAppComprobante) {
      enviarWhatsAppRecibo({
        celular,
        linkEmailEnable,
      });
    }

    setVisibleEnvios(false);
  };

  const exitEnvios = (e) => {
    setVisibleEnvios(false);
  };

  //console.log(recibos);

  return (
    <Fragment>
      <Menu />
      <Toast ref={toast} />
      <ConfirmDialog />
      {statusAcceso === 0 ? <Spinner /> : null}
      {statusAcceso === 400 ? accesoDenegado() : null}
      {statusAcceso === 200 ? (
        <Fragment>
          <Fragment>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              style={{ align: "center", margin: "1em" }}
            >
              <Button
                icon="pi pi-calendar"
                tooltip="Fechas"
                className="p-button-rounded p-button-success"
                style={{ marginLeft: "1em" }}
                onClick={(e) => calendar()}
              />

              <Button
                icon="pi pi-plus"
                tooltip="Agregar"
                className="p-button-rounded p-button-help"
                style={{ marginLeft: "1em" }}
                onClick={addClick}
              />
              <Button
                icon="pi pi-pencil"
                tooltip="Editar"
                className="p-button-rounded p-button-danger"
                style={{ marginLeft: "1em" }}
                onClick={editClick}
              />
              <Button
                icon="pi pi-ban"
                tooltip="Anular"
                className="p-button-rounded p-button-warning"
                style={{ marginLeft: "1em" }}
                onClick={anularClick}
              />
              <Button
                icon="pi pi-trash"
                tooltip="Eliminar"
                className="p-button-rounded p-button-danger"
                style={{ marginLeft: "1em" }}
                onClick={eliminarClick}
              />
              <Button
                icon="pi pi-times"
                tooltip="Cerrar"
                className="p-button-rounded p-button-primary"
                style={{ marginLeft: "1em" }}
                onClick={exitClick}
              />

              <div className="datatable-responsive-demo">
                <div className="card">
                  <Tooltip target=".export-buttons>button" position="bottom" />
                  <DataTable
                    value={recibos}
                    selection={selectedRow}
                    onSelectionChange={(e) => setSelectedRow(e.value)}
                    selectionMode="single"
                    dataKey="id"
                    header={header}
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-demo"
                    style={{ fontSize: "small", marginTop: "1vw" }}
                    globalFilter={globalFilter}
                    emptyMessage="No hay datos."
                    paginator
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                    rows={500}
                    rowsPerPageOptions={[10, 20, 50, 100, 500, 1000]}
                  >
                    <Column field="id" header="ID" sortable></Column>
                    <Column
                      field="empresas.nombre"
                      header="Empresa"
                      body={empresaTemplate}
                      sortable
                    ></Column>
                    <Column
                      field="cobradores.nombre"
                      header="Cobrador"
                      body={cobradorTemplate}
                      sortable
                    ></Column>
                    <Column
                      field="puntoventa"
                      header="P. Venta"
                      sortable
                    ></Column>
                    <Column field="numero" header="Número" sortable></Column>
                    <Column
                      field="id_rendicion"
                      header="Rendición"
                      body={rendicionTemplate}
                      sortable
                    ></Column>
                    <Column
                      field="id_titular"
                      header="Titular"
                      body={titularTemplate}
                      sortable
                    ></Column>
                    {/*
                    <Column
                      field="id_comprobante"
                      header="ID Comprobante"
                      body={comprobanteTemplate}
                      sortable
                    ></Column>
                    */}
                    <Column
                      field="entrega"
                      header="Entrega"
                      body={entregaTemplate}
                      sortable
                    ></Column>
                    <Column
                      field="rendido"
                      header="Rendido"
                      body={rendidoTemplate}
                      sortable
                    ></Column>
                    <Column
                      field="anulado"
                      header="Anulado"
                      body={anuladoTemplate}
                      sortable
                    ></Column>
                    <Column
                      field="enviado"
                      header="Enviado"
                      body={enviadoTemplate}
                      sortable
                    ></Column>
                    <Column
                      header="Opciones"
                      body={opcionesTemplate}
                      //body={descripcionTemplate}
                    ></Column>
                  </DataTable>
                </div>
              </div>
            </Grid>

            <Dialog
              header={renderHeaderFechas()}
              visible={visibleFechas}
              closable={false}
              footer={renderFooterFechas()}
              breakpoints={{ "960px": "75vw" }}
              style={{ width: "70vw", paddingBottom: "0" }}
              position="top"
            >
              <Grid container spacing={3} style={{ marginTop: "1vw" }}>
                <Grid
                  item
                  xs={12}
                  md={12}
                  style={{ paddingLeft: 0, marginTop: "0em" }}
                />

                <Grid item xs={12} md={3}>
                  <TextField
                    id="cobrador"
                    label="Cobrador"
                    type="number"
                    fullWidth
                    //onKeyDown={handleEnter}
                    value={cobrador ? cobrador.hasta : null}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) => {
                      setCobrador(e.target.value);
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <TextField
                    id="desde"
                    label="Número Desde"
                    type="number"
                    fullWidth
                    //onKeyDown={handleEnter}
                    value={numeros ? numeros.desde : null}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) => {
                      setNumeros({
                        ...numeros,
                        desde: e.target.value,
                      });
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <TextField
                    id="hasta"
                    label="Número Hasta"
                    type="number"
                    fullWidth
                    //onKeyDown={handleEnter}
                    value={numeros ? numeros.hasta : null}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) => {
                      setNumeros({
                        ...numeros,
                        hasta: e.target.value,
                      });
                    }}
                  />
                </Grid>

                              <Grid
                item
                xs={6}
                md={12}
                style={{ marginLeft: "0vw", marginLeft: "0vw" }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      style={{ marginLeft: "1vw", marginRight: "1vw" }}
                      inputId="noRendido"
                      checked={noRendido ? noRendido : false}
                      onChange={(e) => {
                        setNoRendido(e.target.checked);
                      }}
                    />
                  }
                  label="No Rendido"
                  labelPlacement="start"
                />
              </Grid>

                              <Grid
                item
                xs={6}
                md={12}
                style={{ marginLeft: "0vw", marginLeft: "0vw" }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      style={{ marginLeft: "1vw", marginRight: "1vw" }}
                      inputId="rendido"
                      checked={rendido ? rendido : false}
                      onChange={(e) => {
                        setRendido(e.target.checked);
                      }}
                    />
                  }
                  label="Rendido"
                  labelPlacement="start"
                />
              </Grid>


                {/*   
              <Grid
                item
                xs={12}
                md={12}
                style={{ paddingLeft: 0, marginTop: "0em" }}
              >
                {!rows &&
                ((titularId && titularId.length >= 4) ||
                  (titularNombre && titularNombre.length >= 3)) ? (
                  <ProgressBar
                    mode="indeterminate"
                    style={{ height: "6px" }}
                  ></ProgressBar>
                ) : null}
              </Grid>
                  */}
              </Grid>
            </Dialog>

            <Dialog
              header={renderHeader()}
              visible={visible}
              closable={false}
              footer={renderFooter()}
              breakpoints={{ "960px": "75vw" }}
              style={{ width: "50vw", paddingBottom: "0" }}
              position="center"
            >
              <Grid container spacing={3} style={{ marginTop: "1vw" }}>
                {/*
                <Grid item xs={12} md={2}>
                  <TextField
                    value={recibo ? recibo.id : ""}
                    variant="standard"
                    id="id"
                    label="ID"
                    fullWidth
                    disabled={true}
                  />
                </Grid>
                */}

                <Grid item xs={12} md={6}>
                  <Autocomplete
                    id="idEmpresa"
                    fullWidth
                    noOptionsText={"No hay opciones"}
                    options={
                      empresas &&
                      empresas.filter((item) => item.control && item.habilitado)
                        .length > 0
                        ? empresas.filter(
                            (item) => item.control && item.habilitado,
                          )
                        : empresas
                          ? empresas.filter((item) => item.habilitado)
                          : null
                    }
                    value={
                      empresas && recibo
                        ? empresas.find((item) => item.id === recibo.id_empresa)
                        : null
                    }
                    getOptionLabel={(option) => option.nombre || ""}
                    openOnFocus={true}
                    disablePortal
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Empresa"
                        variant="standard"
                        required
                      />
                    )}
                    disabled={selectedRow}
                    onChange={(event, value) => {
                      guardarRecibo({
                        ...recibo,
                        id_empresa: value ? value.id : null,
                      });
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <Autocomplete
                    id="idCobrador"
                    fullWidth
                    noOptionsText={"No hay opciones"}
                    options={
                      cobradores &&
                      cobradores.filter((item) => item.habilitado).length > 0
                        ? cobradores.filter((item) => item.habilitado)
                        : cobradores
                          ? cobradores.filter((item) => item.habilitado)
                          : null
                    }
                    value={
                      cobradores && recibo
                        ? cobradores.find(
                            (item) => item.id === recibo.id_cobrador,
                          )
                        : null
                    }
                    getOptionLabel={(option) => option.nombre || ""}
                    openOnFocus={true}
                    disablePortal
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Cobrador"
                        variant="standard"
                        required
                      />
                    )}
                    onChange={(event, value) => {
                      guardarRecibo({
                        ...recibo,
                        id_cobrador: value ? value.id : null,
                      });
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    value={recibo ? recibo.puntoventa : ""}
                    required
                    variant="standard"
                    id="puntoventa"
                    label="P. Venta"
                    fullWidth
                    disabled={selectedRow}
                    onChange={(e) =>
                      guardarRecibo({
                        ...recibo,
                        puntoventa: e.target.value,
                      })
                    }
                  />
                </Grid>

                {selectedRow ? (
                  <Grid item xs={12} md={4}>
                    <TextField
                      value={recibo ? recibo.numero : ""}
                      required
                      variant="standard"
                      id="numero"
                      label="Número"
                      fullWidth
                      disabled
                    />
                  </Grid>
                ) : (
                  <Fragment>
                    <Grid item xs={12} md={4}>
                      <TextField
                        value={recibo ? recibo.desde : ""}
                        required
                        variant="standard"
                        id="desde"
                        label="Número Desde"
                        fullWidth
                        onChange={(e) =>
                          guardarRecibo({
                            ...recibo,
                            desde: e.target.value,
                          })
                        }
                      />
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <TextField
                        value={recibo ? recibo.hasta : ""}
                        required
                        variant="standard"
                        id="hasta"
                        label="Número Hasta"
                        fullWidth
                        onChange={(e) =>
                          guardarRecibo({
                            ...recibo,
                            hasta: e.target.value,
                          })
                        }
                      />
                    </Grid>
                  </Fragment>
                )}
              </Grid>
            </Dialog>
          </Fragment>
          <Grid item xs={12} sm={12}></Grid>

          <Dialog
            header={renderHeaderEnvios()}
            visible={visibleEnvios}
            closable={false}
            footer={renderFooterEnvios()}
            breakpoints={{ "560px": "75vw" }}
            style={{ width: "70vw", paddingBottom: "0" }}
            position="top"
          >
            <Grid container spacing={3} style={{ margin: "1vw" }}>
              <Grid item xs={12} md={7} style={{ padding: "0.2vw" }} />

              <Grid item xs={12} md={7} style={{ padding: "0.2vw" }}>
                <TextField
                  value={emailAddress ? emailAddress : null}
                  variant="standard"
                  id="email"
                  label="Email"
                  fullWidth
                  onChange={(e) => {
                    if (e.target.value) {
                      guardarEmailAddress(e.target.value);
                    } else {
                      guardarEmailAddress(null);
                      setEmailComprobante(false);
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    style: { color: "red" },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={4} style={{ padding: "0.2vw" }}>
                <TextField
                  value={celular ? celular : null}
                  variant="standard"
                  id="celular"
                  label="Celular"
                  fullWidth
                  onChange={(e) => {
                    if (e.target.value) {
                      guardarCelular(e.target.value);
                    } else {
                      guardarCelular(null);
                      setWhatsAppComprobante(false);
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    style: { color: "red" },
                  }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                md={3}
                style={{
                  paddingLeft: 0,
                  paddingTop: "1vw",
                }}
              >
                <FormControlLabel
                  value="yes"
                  control={
                    <Checkbox
                      color="primary"
                      checked={emailComprobante ? emailComprobante : null}
                      style={{ marginLeft: "1vw" }}
                      disabled={!emailAddress}
                      onChange={(e) => setEmailComprobante(e.target.checked)}
                    />
                  }
                  label="Email"
                  labelPlacement="start"
                  style={{ paddingLeft: ".7vw" }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                md={3}
                style={{
                  paddingLeft: 0,
                  paddingTop: "1vw",
                }}
              >
                <FormControlLabel
                  value="yes"
                  control={
                    <Checkbox
                      color="primary"
                      checked={whatsAppComprobante ? whatsAppComprobante : null}
                      style={{ marginLeft: "1vw" }}
                      disabled={!celular}
                      onChange={(e) => setWhatsAppComprobante(e.target.checked)}
                    />
                  }
                  label="WhatsApp"
                  labelPlacement="start"
                  style={{ paddingLeft: ".7vw" }}
                />
              </Grid>
            </Grid>
          </Dialog>
        </Fragment>
      ) : null}
    </Fragment>
  );
}
